const IconFigma = () => (
    <svg xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" viewBox="0 0 24 24">
        <path fill="#0ACF83" d="M8,24c2.208,0,4-1.792,4-4v-4H8c-2.208,0-4,1.792-4,4S5.792,24,8,24z"/>
        <path fill="#A259FF" d="M4,12c0-2.208,1.792-4,4-4h4v8H8C5.792,16,4,14.208,4,12z"/>
        <path fill="#F24E1E" d="M4,4c0-2.208,1.792-4,4-4h4v8H8C5.792,8,4,6.208,4,4z"/>
        <path fill="#FF7262" d="M12,0h4c2.208,0,4,1.792,4,4s-1.792,4-4,4h-4V0z"/>
        <path fill="#1ABCFE" d="M20,12c0,2.208-1.792,4-4,4s-4-1.792-4-4s1.792-4,4-4S20,9.792,20,12z"/>
    </svg>
);

export default IconFigma;
